// MCP server data
export const mcpServers = [
  {
    id: 'mcp-alpha',
    name: 'MCP Alpha',
    description: 'General purpose AI agent with advanced reasoning capabilities',
    longDescription:
      'MCP Alpha is a state-of-the-art general purpose AI agent designed to handle a wide range of tasks with exceptional reasoning capabilities. Built on the latest neural architecture, it excels at understanding context, generating creative content, and solving complex problems across domains. With its advanced natural language processing and multi-modal capabilities, MCP Alpha serves as your versatile digital assistant for both personal and professional use cases.',
    category: 'General',
    rating: 4.8,
    reviews: 1243,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: 'Free / $10 Pro',
    users: 25600,
    features: [
      'Advanced reasoning capabilities',
      'Multi-modal input processing',
      'Context-aware responses',
      'Memory retention across sessions',
      'Customizable personality',
      'API integration with popular services',
      'Regular knowledge updates',
    ],
    specs: {
      memory: '16GB equivalent',
      processing: 'Neural processing at 45 TFLOPS',
      storage: 'Unlimited cloud storage',
      uptime: '99.98%',
    },
    company: {
      name: 'Nexus AI Systems',
      verified: true,
      founded: '2019',
      website: 'https://example.com/nexus',
    },
  },
  {
    id: 'new',
    name: 'New',
    description: 'General purpose AI agent with advanced reasoning capabilities',
    longDescription:
      'MCP Servers is a state-of-the-art general purpose AI agent designed to handle a wide range of tasks with exceptional reasoning capabilities. Built on the latest neural architecture, it excels at understanding context, generating creative content, and solving complex problems across domains. With its advanced natural language processing and multi-modal capabilities, MCP Alpha serves as your versatile digital assistant for both personal and professional use cases.',
    category: 'General',
    rating: 4.8,
    reviews: 1243,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: 'Free / $10 Pro',
    users: 25600,
    features: [
      'Advanced reasoning capabilities',
      'Multi-modal input processing',
      'Context-aware responses',
      'Memory retention across sessions',
      'Customizable personality',
      'API integration with popular services',
      'Regular knowledge updates',
    ],
    specs: {
      memory: '16GB equivalent',
      processing: 'Neural processing at 45 TFLOPS',
      storage: 'Unlimited cloud storage',
      uptime: '99.98%',
    },
    company: {
      name: 'Nexus AI Systems',
      verified: true,
      founded: '2019',
      website: 'https://example.com/nexus',
    },
  },
  {
    id: 'featured',
    name: 'Featured',
    description: 'General purpose AI agent with advanced reasoning capabilities',
    longDescription:
      'Featured is a state-of-the-art general purpose AI agent designed to handle a wide range of tasks with exceptional reasoning capabilities. Built on the latest neural architecture, it excels at understanding context, generating creative content, and solving complex problems across domains. With its advanced natural language processing and multi-modal capabilities, MCP Alpha serves as your versatile digital assistant for both personal and professional use cases.',
    category: 'General',
    rating: 4.8,
    reviews: 1243,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: 'Free / $10 Pro',
    users: 25600,
    features: [
      'Advanced reasoning capabilities',
      'Multi-modal input processing',
      'Context-aware responses',
      'Memory retention across sessions',
      'Customizable personality',
      'API integration with popular services',
      'Regular knowledge updates',
    ],
    specs: {
      memory: '16GB equivalent',
      processing: 'Neural processing at 45 TFLOPS',
      storage: 'Unlimited cloud storage',
      uptime: '99.98%',
    },
    company: {
      name: 'Nexus AI Systems',
      verified: true,
      founded: '2019',
      website: 'https://example.com/nexus',
    },
  },
  {
    id: 'popular',
    name: 'Popular',
    description: 'General purpose AI agent with advanced reasoning capabilities',
    longDescription:
      'MCP Alpha is a state-of-the-art general purpose AI agent designed to handle a wide range of tasks with exceptional reasoning capabilities. Built on the latest neural architecture, it excels at understanding context, generating creative content, and solving complex problems across domains. With its advanced natural language processing and multi-modal capabilities, MCP Alpha serves as your versatile digital assistant for both personal and professional use cases.',
    category: 'General',
    rating: 4.8,
    reviews: 1243,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: 'Free / $10 Pro',
    users: 25600,
    features: [
      'Advanced reasoning capabilities',
      'Multi-modal input processing',
      'Context-aware responses',
      'Memory retention across sessions',
      'Customizable personality',
      'API integration with popular services',
      'Regular knowledge updates',
    ],
    specs: {
      memory: '16GB equivalent',
      processing: 'Neural processing at 45 TFLOPS',
      storage: 'Unlimited cloud storage',
      uptime: '99.98%',
    },
    company: {
      name: 'Nexus AI Systems',
      verified: true,
      founded: '2019',
      website: 'https://example.com/nexus',
    },
  },

  {
    id: 'creative-forge',
    name: 'Creative Forge',
    description: 'Specialized in creative tasks like writing, design, and ideation',
    longDescription:
      'Creative Forge is a specialized AI agent designed specifically for creative professionals and enthusiasts. It excels at generating high-quality written content, assisting with design concepts, and facilitating ideation processes. With its deep understanding of creative principles and extensive training on artistic works, Creative Forge helps users overcome creative blocks, refine their ideas, and produce polished creative outputs across various mediums and styles.',
    category: 'Creative',
    rating: 4.6,
    reviews: 892,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$5 / $15 Pro',
    users: 18400,
    features: [
      'Advanced content generation',
      'Style matching and adaptation',
      'Visual concept sketching',
      'Narrative structure assistance',
      'Mood and tone analysis',
      'Creative prompt expansion',
      'Collaborative ideation tools',
    ],
    specs: {
      memory: '12GB equivalent',
      processing: 'Neural processing at 38 TFLOPS',
      storage: '500GB cloud storage',
      uptime: '99.95%',
    },
    company: {
      name: 'Artisan Digital',
      verified: true,
      founded: '2020',
      website: 'https://example.com/artisan',
    },
  },
  {
    id: 'code-nexus',
    name: 'Code Nexus',
    description: 'Expert coding assistant with multi-language support',
    longDescription:
      'Code Nexus is a specialized AI agent built for software developers and programmers. With support for over 40 programming languages and frameworks, it provides intelligent code completion, debugging assistance, and optimization suggestions. Code Nexus understands software architecture principles and can help with everything from small code snippets to large system designs. Its context-aware suggestions and explanations make it an invaluable tool for both beginners and experienced developers.',
    category: 'Coding',
    rating: 4.9,
    reviews: 2198,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$8 / $20 Pro',
    users: 31200,
    features: [
      'Support for 40+ programming languages',
      'Intelligent code completion',
      'Bug detection and fixing',
      'Code optimization suggestions',
      'Architecture pattern recommendations',
      'Documentation generation',
      'Integration with popular IDEs',
    ],
    specs: {
      memory: '20GB equivalent',
      processing: 'Neural processing at 52 TFLOPS',
      storage: '1TB cloud storage',
      uptime: '99.99%',
    },
    company: {
      name: 'DevMatrix Solutions',
      verified: true,
      founded: '2018',
      website: 'https://example.com/devmatrix',
    },
  },
  {
    id: 'data-oracle',
    name: 'Data Oracle',
    description: 'Specialized in data analysis, visualization, and insights',
    longDescription:
      'Data Oracle is a powerful AI agent designed for data scientists, analysts, and business intelligence professionals. It excels at processing large datasets, generating insightful visualizations, and extracting meaningful patterns from complex information. With its advanced statistical modeling capabilities and intuitive data transformation tools, Data Oracle helps users make data-driven decisions and communicate findings effectively through clear, compelling visualizations and reports.',
    category: 'Data Analysis',
    rating: 4.7,
    reviews: 756,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$12 / $30 Pro',
    users: 15800,
    features: [
      'Advanced statistical analysis',
      'Automated data cleaning',
      'Interactive visualization generation',
      'Predictive modeling',
      'Natural language data querying',
      'Anomaly detection',
      'Automated reporting',
    ],
    specs: {
      memory: '24GB equivalent',
      processing: 'Neural processing at 60 TFLOPS',
      storage: '2TB cloud storage',
      uptime: '99.97%',
    },
    company: {
      name: 'Insight Analytics',
      verified: true,
      founded: '2017',
      website: 'https://example.com/insight',
    },
  },
  {
    id: 'enterprise-hub',
    name: 'Enterprise Hub',
    description: 'Secure, scalable solution for enterprise workflows',
    longDescription:
      'Enterprise Hub is a comprehensive AI solution designed specifically for large organizations with complex workflows and stringent security requirements. It provides a secure, scalable platform for deploying AI capabilities across departments while maintaining compliance with industry regulations. With its robust permission system, audit trails, and enterprise-grade encryption, Enterprise Hub enables businesses to leverage AI for productivity and innovation while protecting sensitive information and maintaining governance.',
    category: 'Enterprise',
    rating: 4.5,
    reviews: 432,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: 'Custom Pricing',
    users: 8900,
    features: [
      'Enterprise-grade security',
      'Role-based access control',
      'Compliance management',
      'Workflow automation',
      'Cross-department collaboration',
      'Custom integration capabilities',
      'Detailed audit logging',
    ],
    specs: {
      memory: '32GB equivalent',
      processing: 'Neural processing at 75 TFLOPS',
      storage: '5TB cloud storage',
      uptime: '99.999%',
    },
    company: {
      name: 'Cortex Enterprise Solutions',
      verified: true,
      founded: '2015',
      website: 'https://example.com/cortex',
    },
  },
  {
    id: 'quantum-core',
    name: 'Quantum Core',
    description: 'Next-generation AI with quantum computing capabilities',
    longDescription:
      'Quantum Core represents the cutting edge of AI technology, leveraging quantum computing principles to solve problems that are intractable for traditional systems. This experimental platform excels at complex simulations, optimization problems, and advanced cryptography. While still in beta, Quantum Core offers a glimpse into the future of AI, providing unprecedented computational power for specialized applications that require quantum-inspired algorithms and massive parallel processing capabilities.',
    category: 'General',
    rating: 4.3,
    reviews: 321,
    status: 'Beta',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$15 / $40 Pro',
    users: 5600,
    features: [
      'Quantum-inspired algorithms',
      'Complex system simulation',
      'Advanced optimization',
      'Cryptographic applications',
      'Molecular modeling',
      'Financial modeling',
      'Research-grade computation',
    ],
    specs: {
      memory: 'Quantum memory equivalent',
      processing: 'Quantum-inspired processing',
      storage: '3TB cloud storage',
      uptime: '98.5% (Beta)',
    },
    company: {
      name: 'Quantum Frontier',
      verified: true,
      founded: '2021',
      website: 'https://example.com/quantum',
    },
  },
  {
    id: 'game-master',
    name: 'Game Master',
    description: 'AI agent specialized in gaming assistance and strategy',
    longDescription:
      'Game Master is an AI agent designed specifically for gamers and game developers. It provides strategic advice, gameplay optimization, and creative assistance for both players and creators. For players, it offers personalized coaching, strategy development, and real-time assistance across popular game titles. For developers, it helps with game balancing, level design, narrative development, and player experience optimization, making it an invaluable tool for the gaming community.',
    category: 'Gaming',
    rating: 4.7,
    reviews: 1876,
    status: 'New',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$7 / $18 Pro',
    users: 12400,
    features: [
      'Game strategy optimization',
      'Real-time gameplay assistance',
      'Character build recommendations',
      'Level design assistance',
      'Game balancing tools',
      'Narrative development',
      'Player behavior analysis',
    ],
    specs: {
      memory: '18GB equivalent',
      processing: 'Neural processing at 48 TFLOPS',
      storage: '750GB cloud storage',
      uptime: '99.9%',
    },
    company: {
      name: 'Ludic Intelligence',
      verified: true,
      founded: '2022',
      website: 'https://example.com/ludic',
    },
  },
  {
    id: 'neural-architect',
    name: 'Neural Architect',
    description: 'Advanced AI for complex problem-solving and modeling',
    longDescription:
      'Neural Architect is a sophisticated AI agent designed for researchers, scientists, and engineers working on complex modeling and simulation tasks. It excels at creating neural network architectures, optimizing existing models, and solving multidimensional problems across scientific domains. With its advanced mathematical capabilities and intuitive interface, Neural Architect helps users design, test, and implement cutting-edge AI solutions for their specific research and engineering challenges.',
    category: 'General',
    rating: 4.6,
    reviews: 543,
    status: 'Online',
    image: '/assets/agents-dummy/placeholder.svg?height=200&width=200',
    price: '$10 / $25 Pro',
    users: 9800,
    features: [
      'Neural network architecture design',
      'Model optimization',
      'Complex system modeling',
      'Research simulation tools',
      'Hyperparameter tuning',
      'Transfer learning capabilities',
      'Scientific visualization',
    ],
    specs: {
      memory: '22GB equivalent',
      processing: 'Neural processing at 58 TFLOPS',
      storage: '1.5TB cloud storage',
      uptime: '99.96%',
    },
    company: {
      name: 'Synaptic Systems',
      verified: true,
      founded: '2019',
      website: 'https://example.com/synaptic',
    },
  },
]

// Filter and sort options
export const categories = ['General', 'Creative', 'Coding', 'Data Analysis', 'Enterprise', 'Gaming']
export const sortOptions = ['Popularity', 'Rating', 'Price: Low to High', 'Price: High to Low', 'Newest']

// Sample reviews
export const sampleReviews = [
  {
    id: 1,
    user: {
      name: 'Alex Johnson',
      image: '/assets/agents-dummy/placeholder.svg?height=40&width=40',
      verified: true,
    },
    rating: 5,
    date: '2023-12-15',
    title: 'Exceptional performance and reliability',
    content:
      "I've been using MCP Alpha for the past 6 months and I'm consistently impressed by its capabilities. The reasoning is truly advanced and it handles complex tasks with ease. The Pro version is absolutely worth the investment for the additional features.",
    likes: 42,
    dislikes: 3,
    replies: 5,
  },
  {
    id: 2,
    user: {
      name: 'Sarah Chen',
      image: '/assets/agents-dummy/placeholder.svg?height=40&width=40',
      verified: true,
    },
    rating: 4,
    date: '2023-11-28',
    title: 'Great for most tasks, occasional hiccups',
    content:
      'MCP Alpha has become an essential part of my workflow. It handles most tasks brilliantly, though occasionally struggles with very specialized domain knowledge. The customer support is responsive and helpful when issues arise.',
    likes: 28,
    dislikes: 2,
    replies: 3,
  },
  {
    id: 3,
    user: {
      name: 'Michael Rodriguez',
      image: '/assets/agents-dummy/placeholder.svg?height=40&width=40',
      verified: false,
    },
    rating: 5,
    date: '2023-10-12',
    title: 'A game-changer for productivity',
    content:
      "I can't overstate how much MCP Alpha has improved my productivity. The context awareness and memory retention across sessions means I spend less time repeating myself and more time getting actual work done. Highly recommended!",
    likes: 56,
    dislikes: 1,
    replies: 7,
  },
  {
    id: 4,
    user: {
      name: 'Emily Parker',
      image: '/assets/agents-dummy/placeholder.svg?height=40&width=40',
      verified: true,
    },
    rating: 3,
    date: '2023-09-05',
    title: 'Good but needs improvement in specialized areas',
    content:
      'While MCP Alpha performs well for general tasks, I found it lacking when dealing with my specialized field of quantum chemistry. It often provides oversimplified answers that require significant correction. That said, the developers seem committed to improvement.',
    likes: 15,
    dislikes: 8,
    replies: 4,
  },
  {
    id: 5,
    user: {
      name: 'David Kim',
      image: '/assets/agents-dummy/placeholder.svg?height=40&width=40',
      verified: true,
    },
    rating: 5,
    date: '2023-08-22',
    title: "Best AI assistant I've used",
    content:
      'After trying numerous AI assistants, MCP Alpha stands head and shoulders above the rest. The reasoning capabilities are truly impressive, and it feels like working with a knowledgeable colleague rather than a simple tool. The price point is very reasonable for the value provided.',
    likes: 87,
    dislikes: 4,
    replies: 12,
  },
]
